import { action, Action } from 'easy-peasy';
import { CSSProperties } from 'react';
import { QualityCommercialConfig, subFuncInfo } from '@/types';

export enum ExtensionType {
    popUp = 'popUp',
    fullCover = 'fullCover',
    panel = 'panel',
}

export interface IExtensionModel {
    display: boolean;
    style: CSSProperties;
    setDisplay: Action<IExtensionModel, boolean>;
    setStyle: Action<IExtensionModel, CSSProperties>;
    type?: ExtensionType;
    setType: Action<IExtensionModel, ExtensionType>;
    /**
     * 变清晰商业化配置
     */
    qualityCommercialConfig: QualityCommercialConfig;
    setQualityCommercialConfig: Action<IExtensionModel, QualityCommercialConfig>;
}

export const extensionModel: IExtensionModel = {
    display: false,
    setDisplay: action((state, payload) => {
        state.display = payload;
    }),
    style: {},
    setStyle: action((state, payload) => {
        state.style = payload;
    }),
    type: ExtensionType.popUp,
    setType: action((state, payload) => {
        state.type = payload;
    }),
    qualityCommercialConfig: subFuncInfo,
    setQualityCommercialConfig: action((state, value) => {
        state.qualityCommercialConfig = value;
    }),
};
